module.exports = __webpack_public_path__ + "okta-logo-icon-75db5cbc9c31c848f9e69dfb35d5291a.png";